"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var cardToIconMapping = {
    'American Express': 'cc-american-express',
    Visa: 'cc-visa',
    JCB: 'cc-jcb',
    Discover: 'cc-discover',
    MasterCard: 'cc-mastercard',
};
var CreditCardIcon = /** @class */ (function (_super) {
    tslib_1.__extends(CreditCardIcon, _super);
    function CreditCardIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CreditCardIcon.prototype, "cardIconClass", {
        get: function () {
            return cardToIconMapping[this.props.cardType];
        },
        enumerable: true,
        configurable: true
    });
    CreditCardIcon.prototype.render = function () {
        if (!this.props.cardType) {
            return null;
        }
        return (React.createElement("div", { className: this.cardIconClass }));
    };
    return CreditCardIcon;
}(React.Component));
exports.default = CreditCardIcon;
//# sourceMappingURL=credit_card_icon.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/legacy/credit_card_icon.js
// module id = LLwy
// module chunks = 20 21 22